import React, { useEffect, useState } from "react";
import DetailsModal from "./DetailsModal";
import TicketActions from "../../Actions/TicketActions";
import ticketStore from "../../Stores/TicketStores";
import TicketConstants from "../../Constants/TicketConstants";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "../../Context/LanguageContext";
import { toast } from "react-toastify";
import commonUtils from "../../helpers/commonUtils";

export default function TicketDetails({
  selTicketId,
  handleClose,
  getTicketAfterUpdate,
  state,
}) {
  const { language, localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [isDisable, setIsDisable] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [ticketId, setTicketID] = useState(null);
  const [closeReason, setCloseReason] = useState("");

  useEffect(() => {
    setGlobalSpinner(true);
    TicketActions.getTicketDetails(
      selTicketId,
      sessionStorage.getItem("userid"),
      language,
      false,
    );
  }, []);

  useEffect(() => {
    function getSingleStatusUpdateSuccess() {
      var res = ticketStore.getResult();
      toast.success(localization.ticketUpdatedSuccess);
      setIsDisable(true);
      commonUtils.hideModalPopUp("TicketDetailsModalClose");
      getTicketAfterUpdate();
      // setGlobalSpinner(false);
    }

    function getSingleStatusUpdateFailure() {
      var res = ticketStore.getResult();
      toast.error(res);
      setGlobalSpinner(false);
    }
    ticketStore.addChangeListener(
      TicketConstants.UPDATE_TICKET_STATUS_DETAIL_SUCCESS,
      getSingleStatusUpdateSuccess,
    );
    ticketStore.addChangeListener(
      TicketConstants.UPDATE_TICKET_STATUS_DETAIL_FAILURE,
      getSingleStatusUpdateFailure,
    );
    return () => {
      ticketStore.removeChangeListener(
        TicketConstants.UPDATE_TICKET_STATUS_DETAIL_SUCCESS,
        getSingleStatusUpdateSuccess,
      );
      ticketStore.removeChangeListener(
        TicketConstants.UPDATE_TICKET_STATUS_DETAIL_FAILURE,
        getSingleStatusUpdateFailure,
      );
    };
  }, []);

  function handelUpdate() {
    setGlobalSpinner(true);
    TicketActions.UpdateStatus(
      {
        id: ticketId,
        status: "Close",
        reason: closeReason,
      },
      false,
      language,
      true,
    );
  }

  function handleButton(_value) {
    if (
      state.toLowerCase() !== "close" &&
      (commonUtils.isManageTicketUser() ||
        commonUtils.isUserOrganisationAdmin() ||
        commonUtils.hasManageTicketPermission())
    )
      setIsShow(_value);
  }

  function handelDialogClose() {
    setIsDisable(false);
    setIsShow(false);
    handleClose();
  }

  return (
    <div
      className="modal in dialogBox "
      id="MsgModalCenter"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="MsgModalCenterTitle"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-dialog-centered widthCustomize"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="addPruefPlan">
              {localization.ticketdetails}
            </h5>

            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="TicketDetailsModalClose"
              onClick={handelDialogClose}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div
            className="modal-body"
            // style={{ maxHeight: "60vh", overflow: "auto" }}
          >
            <div className="w-100 ml-auto mr-auto rowStyle">
              <DetailsModal
                showButton={handleButton}
                setTicketID={setTicketID}
                setIsDisable={() => {}}
              />
            </div>
          </div>
          <div className="modal-footer">
            <div className="form-group marProp">
              {isShow && (
                <>
                  <div className="row form-outline mb-4">
                    <input
                      type="text"
                      id="closeReason"
                      name="closeReason"
                      className="form-control"
                      placeholder={localization.enterReason}
                      required
                      value={closeReason}
                      onChange={(e) => {
                        setCloseReason(e.target.value);
                      }}
                    />
                  </div>
                  <div className="row justify-content-center">
                    <button
                      type="button"
                      className="btn btn-primary mb-4 "
                      disabled={isDisable || closeReason.trim() == ""}
                      onClick={handelUpdate}
                    >
                      {localization.ticketClose}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
